import { render } from "./InfoMovie.vue?vue&type=template&id=43d6f6ce&scoped=true"
import script from "./InfoMovie.vue?vue&type=script&lang=js"
export * from "./InfoMovie.vue?vue&type=script&lang=js"

import "./InfoMovie.vue?vue&type=style&index=0&id=43d6f6ce&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43d6f6ce"]])

export default __exports__